import { render } from "./EdmDetailsEditCard.vue?vue&type=template&id=7a04d8da&scoped=true"
import script from "./EdmDetailsEditCard.vue?vue&type=script&lang=js"
export * from "./EdmDetailsEditCard.vue?vue&type=script&lang=js"

import "./EdmDetailsEditCard.vue?vue&type=style&index=0&id=7a04d8da&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a04d8da"]])

export default __exports__